// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { setRenewalAdminHighlightedIds } from 'redux/modules/projectTracker/actions'

const updateRenewalAdminHighlightedData = highlightedTransactionIds => (dispatch, getState) => {
  const { data } = getState().projectTracker.renewalAdmin

  let deletedPathSelected = false
  let nonDeletedPathSelected = false
  let canceledTransactionSelected = false
  let nonCanceledTransactionSelected = false
  let expiredTransactionSelected = false
  let eligibilityStatusNullSelected = false
  const selectedInternalStatusIds = new Set()

  data.forEach(transaction => {
    // if this transaction isn't highlighted, we don't care about it
    if (highlightedTransactionIds.includes(transaction.transactionId) === false) {
      return
    }

    if (!deletedPathSelected && transaction.path_deleted_ind) {
      deletedPathSelected = true
    }
    if (!nonDeletedPathSelected && !transaction.path_deleted_ind) {
      nonDeletedPathSelected = true
    }
    // if there are no canceled transactions selected but this one is,
    // track it.
    if (!canceledTransactionSelected && transaction.cancelled_ind) {
      canceledTransactionSelected = true
    }

    // if there are no non-canceled transactions selected but this one is,
    // track it.
    if (!nonCanceledTransactionSelected && !transaction.cancelled_ind) {
      nonCanceledTransactionSelected = true
    }

    // if there are no expired transactions selected but this one is,
    // track it.
    if (!expiredTransactionSelected && transaction.eligibility_status_cd === 6) {
      expiredTransactionSelected = true
    }

    // if there are no transactions with eligibility status cd null selected but this one is,
    // track it.
    if (!eligibilityStatusNullSelected && transaction.eligibility_status_cd === 0) {
      eligibilityStatusNullSelected = true
    }

    // add the internal_status_cd to the tracked Set.
    selectedInternalStatusIds.add(transaction.internal_status_cd)
  })

  // then save that updated list to redux
  dispatch(setRenewalAdminHighlightedIds({
    deletedPathSelected,
    nonDeletedPathSelected,
    canceledTransactionSelected,
    eligibilityStatusNullSelected,
    expiredTransactionSelected,
    highlightedTransactionIds,
    nonCanceledTransactionSelected,
    // convert it to an array for store in redux.
    selectedInternalStatusIds: Array.from(selectedInternalStatusIds),
  }))
}

export default updateRenewalAdminHighlightedData
